<template>
  <div class="my-form">
    <div class="form-title">编辑账户
      <Icon type="edit"></Icon>
    </div>
    <Form :model="postdata" :label-width="120">
      <FormItem label="组织机构">
        <RadioGroup v-model="postdata.FilialeID">
          <Radio v-for="item in radio.Filiales" :label="item.ID" :key="item.ID">{{item.FilialeName}}</Radio>
        </RadioGroup>
      </FormItem>
      <!--<FormItem label="是否服务人员">
        <RadioGroup v-model="postdata.IsWorker">
          <Radio label="1">是</Radio>
          <Radio label="0">否</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="是否地市管理员">
        <RadioGroup v-model="postdata.IsMannager">
          <Radio label="1">是</Radio>
          <Radio label="0">否</Radio>
        </RadioGroup>
      </FormItem>-->
      <FormItem label="用户类型">
        <RadioGroup v-model="postdata.EmployeesType">
          <Radio :label="1">售后</Radio>
          <Radio :label="2">客服</Radio>
          <Radio :label="3">业务员</Radio>
          <Radio :label="4">代理商</Radio>
          <!--<Radio :label="5">管理员</Radio>-->
        </RadioGroup>
      </FormItem>
       <FormItem label="员工编号 ">
        <Input v-model="postdata.LiquidCode" style="width:500px" placeholder="请填写员工编号"></Input>
      </FormItem>
      <FormItem label="姓名 ">
        <Input v-model="postdata.Name" style="width:500px" placeholder="请填写姓名"></Input>
      </FormItem>
      <FormItem label="电话号码 ">
        <Input v-model="postdata.TelNum" style="width:500px" placeholder="请填写电话"></Input>
      </FormItem>
      <FormItem label="用户名 ">
        <Input v-model="postdata.UserName" style="width:500px" placeholder="请填写用户名"></Input>
      </FormItem>
      <FormItem label="密码 ">
        <Input v-model="postdata.PassWord" style="width:500px" placeholder="请填写密码"></Input>
      </FormItem>
      <FormItem label="代理运营商">
         <Select v-model="postdata.AgentDealerId" filterable style="width:200px">
            <Option v-for="item in select.AgentDealer" :value="item.ID" :key="item.ID">{{ item.Name }}</Option>
        </Select>
      </FormItem>
      <FormItem>
        <Button @click="SubmitData" type="primary">提交</Button>
        <Button @click="BackList" type="default" style="margin-left: 8px">返回</Button>
      </FormItem>
    </Form>
    <Spin size="large" fix v-if="false"></Spin>
  </div>
</template>

<script>
export default {
  data() {
    return {
      spinShow: false,
      select: {
        AgentDealer: []
      },
      radio: {
        Filiales: []
      },
      postdata: {
        LiquidCode: "",
        Name: "",
        TelNum: "",
        UserName: "",
        PassWord: "",
        FilialeID: "",
        SuperiorEmployeeID: 1,
        AgentId: 0,
        AgentDealerId: "",
        IsSystem: 0,
        EmployeesType: "",
        _CreateBy: 0,
        _CreateTime: "",
        _IsDelete: 0,
        _UpdateBy: 0,
        _UpdateTime: ""
      }
    };
  },
  methods: {
    BackList: function() {
      this.$router.push({ name: "dealer_agentlist" });
    },
    SubmitData: function() {
      var that = this;
      var url = "Employee/EditAgent";
      this.$http.post(url, that.postdata).then(res => {
        var modaltitle = "";
        if (res.data != "success") {
          modaltitle = res.data;
        } else {
          modaltitle = "提交成功！";
        }
        this.$Modal.info({
          title: "提示",
          content: modaltitle
        });
        this.$router.push({ name: "dealer_agentlist" });
      });
    },
    GetAgent: function(id) {
      var that = this;
      this.$http
        .get("Employee/GetEmployee", { params: { id: id } })
        .then(res => {
          that.postdata = res.data;
        })
        .then(res => {
          that.spinShow = false;
        });
    },
    GetAgentDealer: function() {//查询代理运营商
      let that = this;
      that.$http.get("Employee/GetAgentDealer").then(res => {
        that.select.AgentDealer = res.data;
      });
    },
    GetFiliales: function() {//查询组织机构
      let that = this;
      that.$http.get("Filiale/GetFiliales").then(res => {
        that.radio.Filiales = res.data;
      });
    }
  },
  watch: {},
  created: function() {
    var that = this;
    that.spinShow = true;
    that.GetFiliales();
    that.GetAgentDealer();
    that.GetAgent(this.$route.query.id);
  }
};
</script>

<style>
</style>
